package com.shadowings.gero.data.lessons.chapter1

import androidx.compose.foundation.layout.Row
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.*

fun getChap1ChatContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_investighiamo,
            content = Res.string.exp_content_eccoci_al_tempio_di_bastet,
            face = Faces.Happy,
            composable = {
                MdCWord(
                    word = "D58-D36:D21-E20",
                    rtl = false,
                    cart = true,
                    size = 96.dp
                )
            },
        ),
        ExplanationContent(
            title = Res.string.exp_title_investighiamo,
            content = Res.string.exp_content_sta_succedendo_una_cosa_strana,
            face = Faces.Serious,
        ),
        ExplanationContent(
            title = Res.string.exp_title_investighiamo,
            content = Res.string.exp_content_in_questa_stanza_ci_sono_molte_mummie_di_gatt,
            face = Faces.Serious,
            image = Res.drawable.cat_mummy,
            applyFilter = false,
            imageSize = 0.5f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_investighiamo,
            content = Res.string.exp_content_questa_pratica_era_molto_diffusa_come_offerta,
            face = Faces.Happy,
            image = Res.drawable.cat_ohno,
            applyFilter = false,
            imageSize = 0.35f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_investighiamo,
            content = Res.string.exp_content_nilo_ci_rimasto_di_sasso,
            face = Faces.Surprised,
        ),
        ExplanationContent(
            title = Res.string.exp_title_investighiamo,
            content = Res.string.exp_content_comunque_la_cosa_strana_un_altra,
            face = Faces.Serious,
        ),
        ExplanationContent(
            title = Res.string.exp_title_investighiamo,
            content = Res.string.exp_content_questa_scritta_sulla_mummia_illuminata,
            face = Faces.Surprised,
            composable = {
                Row {
                    MdCWord("M23-L2", rtl = false, cart = false)
                    MdCWord("V28-D36:Q3-M17-G43B-S34", rtl = false, cart = true)
                }
            },
        ),
        ExplanationContent(
            title = Res.string.exp_title_investighiamo,
            content = Res.string.exp_content_com_possibile,
            face = Faces.Surprised,
            composable = {
                Row {
                    MdCWord("M23-L2", rtl = false, cart = false)
                    MdCWord("V28-D36:Q3-M17-G43B-S34", rtl = false, cart = true)
                }
            },
        ),
        ExplanationContent(
            title = Res.string.exp_title_investighiamo,
            content = Res.string.exp_content_dobbiamo_subito_scoprire_cosa_significa,
            face = Faces.Serious,
            composable = {
                Row {
                    MdCWord("M23-L2", rtl = false, cart = false)
                    MdCWord("V28-D36:Q3-M17-G43B-S34", rtl = false, cart = true)
                }
            },
        ),
        ExplanationContent(
            title = Res.string.exp_title_investighiamo,
            content = Res.string.exp_content_ma_prima,
            face = Faces.Serious,
        ),
        ExplanationContent(
            title = Res.string.exp_title_investighiamo,
            content = Res.string.exp_content_un_bel_quiz_ripassone,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.exp_title_investighiamo,
            content = Res.string.exp_content_andiamo,
            face = Faces.Perfect,
        ),
    )
}